




















import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    props: {
        data: {
            type: Array as PropType<api.FilterCategory[]>,
            required: true,
        },
        selectedData: {
            type: Array as PropType<Array<api.FilterCategory>>,
            required: true,
        },
        showBack: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            expanded: true,
        };
    },
    watch: {
        selectedId: {
            handler(val) {
                if (val === -1) {
                    (this as any).$refs.tree.setCurrentKey();
                }
            },
            deep: true,
        },
    },
    computed: {
        selectedId(): number {
            if (this.selectedData.length === 1) {
                return this.selectedData[0].id;
            }
            return -1;
        },
    },
    methods: {
        currentChange(data) {
            if (this.selectedData.length > 0 && data.id === this.selectedData[0].id) {
                (this.$refs.tree as any).setCurrentKey(null);
                this.selectedData.pop();
            } else {
                this.$set(this.selectedData, 0, data);
            }
        },
        toggleExpand() {
            this.expanded = !this.expanded;
            // eslint-disable-next-line no-underscore-dangle
            for (let i = 0; i < (this.$refs.tree as any).store._getAllNodes().length; i++) {
                // eslint-disable-next-line no-underscore-dangle
                (this.$refs.tree as any).store._getAllNodes()[i].expanded = this.expanded;
            }
        },
    },
});
